export default {
  headerContent: {
    title: 'Bereket Sigorta Ferdi Kaza Sigortası Fiyatları',
    slogan: "Ferdi Kaza Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'FERDİ KAZA SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Bereket Sigorta Ferdi Kaza Sigortası',
    description: {
      title: 'Bereket Sigorta Ferdi Kaza Sigortası Nedir? ',
      content: [
        'Her türlü kazaya karşı korunmasız bir halde bulunulduğundan, yaşamda beklenmedik anlarda gerçekleşen kazalar çoğunlukla zor durumlar yaratırlar ve bu zor zamanların giderilmesi uzun zamanlar alabilir. Ferdi kaza sigortası ile bu tatsız durumların hasarının giderilmesi kolaylaşır ve kısa sürede sigortalı kişinin kendi yaşamına devam etmesi ön görülür.',
        '<strong>Bereket Sigorta ferdi kaza sigortası</strong>, sigortalı kişiyi ani ve beklenmedik durumlar neticesinde gelişecek kazalar sonucu oluşan maddi hasarlara karşı koruma altına alan sigorta türüdür. Böylece bu kazaların ekonomik sorunlar yaşanmadan çözülmesi amaçlanmaktadır.'
      ]
    },
    subContent: {
      title: 'Bereket Sigorta Ferdi Kaza Sigortası Neleri Kapsar?',
      content: [
        {
          paragraph:
            'Kazalar göz önüne alınarak hazırlanan ferdi kaza sigortası, istem dışı oluşacak neredeyse her türlü kazaya karşılık güvence verir. Kapsamları; kaza sonucu yaralanmalar, ısırılma, böcek sokması, zehirlenme, kırılma, kas yıpranması gibi pek çok alana yayılmıştır.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Ferdi Kaza Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Bereket Sigorta Ferdi Kaza Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Bereket Sigorta Ferdi Kaza Sigortası Ana Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Sigorta tarafından temel risk durumları gözetilerek hazırlanan ana teminatların gerçekleşmesi durumunda sigortalı kişiye tazminat ödemesi yapılır. Bu kapsamda;',
          subList: [
            'Kaza sonucu vefat teminatı; sigortalı kişinin kaza nedeniyle olay yerinde ya da ilgili süre içerisinde vefat etmesi halinde poliçede belirlediği yasal varislerine tazminat ödemesi yapılır. Tazminat miktarı iş kollarına göre farklılık göstermektedir.',
            'Kaza sonucu tam veya kısmi maluliyet; sigortalı kişinin kaza sonucunda tam ya da kısmi maluliyete uğraması durumunda sigorta tarafından tazminat ödemesi yapılır. Bu kapsamda ödenecek tutar, poliçede belirlenmiş limit kapsamında gerçekleştirilir.'
          ]
        }
      ]
    },
    {
      title: 'Bereket Sigorta Ferdi Kaza Sigortası Ek Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Sigortanın ana teminatları yeterli gelmediği ya da sigortalı kişi tarafından ek güvenceler talep edildiğinde Bereket Sigorta ek teminatlar sunmaktadır. Bu teminatlar kapsamında;',
          subList: [
            'Kaza sonucu tedavi masrafları; kaza sonucunda oluşmuş ve tedavi gerektiren hasarın karşılanması sigorta limitleri dâhilinde belirlenen çerçeve içinde karşılanır.',
            'Deprem; ferdi kaza sigortası genelde doğal afetleri kapsam dışı tutar ama bu teminat ile sigortalının deprem sonucunda hasara uğraması durumunda fiziksel zararı karşılanmaktadır.'
          ]
        }
      ]
    },
    {
      title:
        'Bereket Sigorta Ferdi Kaza Sigortası Teminat Dışı Durumlar Nelerdir?',
      content: [
        {
          paragraph:
            'Sigorta çoğu kazayı içermesine rağmen bazı durumları kapsam dışında tutmaktadır. ',
          subList: null
        },
        {
          paragraph: 'Bu durumlar;',
          subList: [
            'Her çeşit hastalık sonucu oluşmuş hasarlar,',
            'Yanma, donma, güneş çarpması gibi hasarlar,',
            'Sigortalı kişinin intihar etmesi ya da intihara teşebbüs etmesi,',
            'Alkol ya da uyuşturucu madde kullanımı sonucunda oluşan hasarlar,',
            'Kaza sonucunda yapılmayan ameliyat ve ilgili tedavilerin hasarları,',
            'Savaş ve savaşa bağlı olarak oluşan hasarlar,',
            'Suça karışma neticesinde oluşan hasarlar,',
            'Motosiklet kullanımı ile oluşan hasarlar,',
            'Her türlü spor faaliyeti kapsamında gerçekleşen hasarlar,',
            'Sigortalı kişinin kendisini kasıtlı olarak tehlikeye atması sonucu oluşan hasarlar,',
            'Terör eylemlerine katılma sonucunda oluşacak hasarlar'
          ]
        },
        {
          paragraph:
            'Kaza olarak sayılmamakta ve sigorta kapsamı dışında tutulmaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Bereket Sigorta Ferdi Kaza Sigortası Teminat Bedelleri Nasıl Belirlenir?',
      content: [
        {
          paragraph:
            'Ferdi kaza sigortası teminat bedelleri, seçilen teminatlara ve sigorta yaptıracak kişinin durumundan hareketle belirlenmektedir. Bu doğrultuda teminatların doğru seçilmesi önem taşımaktadır. Ayrıca tehlikeli görülen meslek gruplarının prim fiyatları da yüksek olmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Ferdi Kaza Sigortası Güvenceleri Nelerdir?',
      content: [
        {
          paragraph:
            'Ferdi kaza sigortası güvenceleri çoğu durum için sunulmaktadır; yanma, çıkma, kırık, trafik kazası, yolcu olarak gerçekleştirilen havadaki kazalar, hayvan saldırıları, ev işlerinden doğan kazalara karşı sigorta tarafından güvence sunulmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Ferdi Kaza Sigortası Avantajları Nelerdir?',
      content: [
        {
          paragraph:
            'Bereket Sigorta ferdi kaza sigortası avantajları birden fazla şekilde sayılabilir. Öncelikle ferdi kaza sigortası ile olası kaza durumlarının sonrasındaki süreç kolay atlatılmakta, maddi destek ile yaşam standardı düşmeden sigortalı kişi yaşamına devam edebilecektir. Vefat durumunda ise yakınları alacakları tazminat ile ekonomik açıdan zorluğu düşmeyeceklerdir. Bu halde; sosyal yaşam devam edecektir, eğitime ara verilmeyecektir, borçlar ödenecektir, yapacağı yatırımları sürdürebilecektir. Böylece sigorta yaptırmak için pek çok avantaj kişileri beklemektedir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Bereket Sigorta Ferdi Kaza Sigortası İçin Gerekli Bilgiler / Evraklar Nelerdir?',
      content: [
        {
          paragraph:
            'Ferdi kaza sigortası için gereken belge başlangıçta sadece kimlik belgeleri olmaktadır. Kişinin kimliği ile istenebilecek sağlık durumunu ve iş kolunu gösteren ek belgeler ile sigorta işlemleri kısa sürede başlatılmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Ferdi Kaza Sigortası Zorunlu Mudur?',
      content: [
        {
          paragraph:
            'Ferdi kaza sigortası isteğe bağlı bir sigorta türüdür. Yapılması durumunda önemli avantajlar ve kolaylıklar sunduğu için, yapılması tavsiye edilmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Ferdi Kaza Sigortası Şartları Nelerdir?',
      content: [
        {
          paragraph:
            '18 – 60 yaş aralığındaki herkes bu sigortadan yararlanabilir. Aynı zamanda herhangi bir hastalık durumunda da sigorta geçersizdir. Aksine hüküm koyulmadıkça tüm spor faaliyetleri kapsamında oluşan hasarlar da geçersiz sayılmaktadır. Sigorta kapsamında istenecek ek şartlar poliçede belirtilecektir.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Ferdi Kaza Sigortasından Kimler Yararlanabilir?',
      content: [
        {
          paragraph:
            '18 ve 60 yaş aralığında kişiler sigortadan yararlanabilirken, bu yaşların dışında olan kimselere özel şartlar ile yine sigorta yapılabilmektedir. Ancak söz konusu kişilerin prim ödemeleri farklılık gösterebilir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Bereket Sigorta Ferdi Kaza Sigortasında Yararlanabileceğiniz Hizmetler Nelerdir?',
      content: [
        {
          paragraph:
            'Ana ve ek teminatların yanı sıra ferdi kaza sigortasında yaşamınızı kolaylaştırmak adına ilave hizmetler sunulmaktadır. Bu hizmetler kapsamında; acil yardım, çilingir, elektrik ve su tesisatı ile ilgili sorunlar ve danışma hizmeti verilmektedir. Poliçede belirlenecek limit ve süreler kapsamında yararlanılabilmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Ferdi Kaza Sigortası Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Ferdi kaza sigortası yaptırmak için kimlik belgesi ve duruma göre istenecek ilave belgeler ile başvuru yapabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Bereket Sigorta Ferdi Kaza Sigortasında Vergi İndirimi Var Mıdır?',
      content: [
        {
          paragraph:
            'Teşvik edici bir unsur olarak vergi indirimi, ferdi kaza sigortalarında uygulanmaktadır. Bu kapsamda poliçe kapsamında ödenen prim tutarı üzerinden aylık brüt ücretin %15’i ve brüt asgari ücretin toplam tutarını aşmamak kaydıyla vergi indiriminde kullanılabilmektedir. Vergi indirimi için poliçe belgelerinin iş yerinin muhasebe birimine sunulması yeterli olmaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Bereket Sigorta Ferdi Kaza Sigortasında Dikkat Edilmesi Gerekenler Nelerdir?',
      content: [
        {
          paragraph:
            'Ferdi kaza sigortası, hastalık sonucu oluşan durumları kapsamaz. Bundan ötürü hastalığa bağlı oluşan hasarlar sigorta kapsamı dışında tutulurlar. Aynı zamanda teminatın hangi kaza durumlarında geçerli olduğu da detaylı olarak bilinmelidir. Teminat dışında kalan yani kaza sayılmayan durumlar için sigorta yine ödeme yapmamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Ferdi Kaza Sigortası Hesaplaması Nasıl Yapılır?',
      content: [
        {
          paragraph:
            '<strong>Bereket Sigorta ferdi kaza sigortası hesaplaması  </strong> seçilen teminatlara ve sigortalı olacak kişinin yaşı ve mesleki durumuna göre belirlenmektedir. Meslek grupları üç başlıkta değerlendirilir; el ve fikren çalışanlar, el ile fiziksel çalışanlar, el ile makinede çalışanlar. Bu koşullara göre bedeller belirlenmektedir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Bereket Sigorta Ferdi Kaza Sigortası Prim Ödeme Koşulları Nelerdir?',
      content: [
        {
          paragraph:
            'Prim ödemeleri Türk Lirası ya da Amerikan Doları üzerinden aylık, 3 aylık, 6 aylık ya da senelik olarak ödenmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Ferdi Kaza Sigortası Fiyatları Ne Kadar?',
      content: [
        {
          paragraph:
            '<strong>Ferdi kaza sigortası fiyatları</strong> sigortalı olacak kişinin durumuna ve seçilen bedellere göre belirlenmektedir. Bu yüzden doğru fiyat ancak teklif sonrasında sunulmaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Bereket Sigorta Ferdi Kaza Sigortası Fiyat Teklifi Nasıl Alınır?  ',
      content: [
        {
          paragraph:
            '<strong>Bereket Sigorta ferdi kaza sigortası fiyat teklifi</strong>ni internet sitesi ve çağrı merkezi üzerinden alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Sigorta Dünyası uzmanlarından fiyat teklifi alabilmek için 7 gün 24 saat ulaşım sağlayacağınız çağrı merkezi ve internet başvuru formu bulunmaktadır. Sizden istenecek bilgileri doğru olarak girmeniz önemlidir.',
          subList: null
        },
        {
          paragraph:
            '<strong>Ferdi kaza sigortası fiyat teklifi için başvuru formunu doldurmanız yeterlidir.</strong>',
          subList: null
        }
      ]
    }
  ]
}
